import { IconProps } from "./Icons";

export const IconCamera = ({
  width = 24,
  height = 24,
  color = "#0B3E5F",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M4.5 7.5H7.2L8.7 5.25H15.3L16.8 7.5H19.5C20.3284 7.5 21 8.17157 21 9V18C21 18.8284 20.3284 19.5 19.5 19.5H4.5C3.67157 19.5 3 18.8284 3 18V9C3 8.17157 3.67157 7.5 4.5 7.5Z"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="13.5" r="3.25" stroke={color} strokeWidth="1.8" />
  </svg>
);
